const servicesCarousel = {
  props: {
    dynamicClass: ".c-services-carousel.dynamicLoading",
    compSelector: ".c-services-carousel",
    cssSelector: "JS-services-swiper",
    cssSelectorSwiper: ".swiper-wrapper[data-items-load]",
    nameAttr: "data-items-load",
    config: {
      breakpoints: {
        0: {
          slidesPerView: 1.1,
        },
        425: {
          slidesPerView: 1.5,
        },
        1024: {
          slidesPerView: 2.5,
        },
      },
      spaceBetween: 0,
      loopedSlides: 1,
      loop: false,
      grabCursor: true,
      wrapperClass: "swiper-wrapper",
      scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true,
        hide: true,
      },
    },
  },
  init: function () {
    bcl.u.loadStyleSheet("/etc.clientlibs/barcelo/clientlibs/clientlib-servicesCarousel.css", this.props.dynamicClass);

    bcl.u.swiper.init(document, this.props);
  },
};

export default servicesCarousel;
